import { createFileRoute } from '@tanstack/react-router'

import { TermsOfUsePage } from '@/features/legal'
import { buildPageTitle } from '@/shared/lib/page-title'

export const Route = createFileRoute('/termos-de-uso')({
  head: () => ({
    meta: [{ title: buildPageTitle('Termos de Uso') }]
  }),
  component: TermsOfUsePage
})
